import { areCybusVolumeEquals, Capability, type CybusVolume } from '../../../../../../domain'

import type { SubscriptionFilterArgs } from '../../../../../../application'

import { BaseSubscriptionStrategy } from '../Base'
import { mapBaseVolume } from './Base'

export class VolumesStrategy extends BaseSubscriptionStrategy<'volumes', never> {
    protected override readonly supportedFilters: (keyof SubscriptionFilterArgs)[] = ['service']

    protected override readonly areEquals = areCybusVolumeEquals

    override readonly requiredPermissions = [Capability.VOLUMES_READ]

    override retrieveAll ({ service }: SubscriptionFilterArgs): Promise<CybusVolume[]> {
        return this.request<'/api/volumes', 'GET', CybusVolume[]>({
            capability: Capability.VOLUMES_READ,
            method: 'GET',
            path: '/api/volumes',
            authenticate: true,
            handlers: {
                200: (response) =>
                    response.getJson().then(({ Volumes: [...Volumes] }) =>
                        Volumes.reduce<CybusVolume[]>((r, volume) => {
                            const cybusVolume = mapBaseVolume(volume)
                            return service && service !== cybusVolume.service ? r : [...r, cybusVolume]
                        }, [])
                    ),
            },
        })
    }
}
